import React from "react";

const EyeOff = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="13.411" height="11.582" viewBox="0 0 13.411 11.582">
			<path
				id="eye-off"
				d="M7.6,6.658,9.534,8.584v-.1A1.829,1.829,0,0,0,7.706,6.658H7.6m-2.621.488.945.945a1.679,1.679,0,0,0-.049.4,1.829,1.829,0,0,0,1.829,1.829,1.72,1.72,0,0,0,.4-.049l.945.945A3.028,3.028,0,0,1,4.981,7.145M1.61,3.774,3,5.164l.274.274A7.213,7.213,0,0,0,1,8.486a7.206,7.206,0,0,0,9.376,4.06l.262.256,1.78,1.78.774-.774L2.384,3M7.706,5.438a3.048,3.048,0,0,1,3.048,3.048A2.927,2.927,0,0,1,10.534,9.6l1.786,1.786a7.22,7.22,0,0,0,2.091-2.9A7.2,7.2,0,0,0,5.267,4.341L6.59,5.652A3.078,3.078,0,0,1,7.706,5.438Z"
				transform="translate(-1 -3)"
				fill="#fff"
				opacity="0.5"
			/>
		</svg>
	);
};

export default EyeOff;
